import React from "react"
import { TestimonialSection } from "../ui/testimonial"
import { getTestimonialForPage } from "../../lib/testimonials"
import { useLocation } from "react-router-dom"
import { cn } from "../../lib/utils"

interface TestimonialsSectionProps {
  className?: string;
}

export function TestimonialsSection({ className }: TestimonialsSectionProps) {
  const location = useLocation();
  const pageName = location.pathname === "/" ? "home" : location.pathname.replace(/^\/|\/$/g, '').replace(/\//g, '_');
  const testimonial = getTestimonialForPage(pageName) || getTestimonialForPage('home');
  
  return (
    <TestimonialSection
      title="Client Success Stories"
      description="Real outcomes from organisations that have partnered with us"
      testimonial={testimonial!}
      className={cn("bg-primary/5", className)}
    />
  )
}
